export class zoneOfservice {
  id: number;
  schoolId: number;
  busId: number;
  name: string;
  //color: string;
  coordZone: string;
  centroid: string;
  Bus: any[];
  
  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/models/zoneOfService.ts